import { render, staticRenderFns } from "./AacademicaMedicineFormList.vue?vue&type=template&id=22f1c9c7"
import script from "./AacademicaMedicineFormList.vue?vue&type=script&lang=js"
export * from "./AacademicaMedicineFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports